<div class="progress-bar-wrapper" *ngIf="progressBarData">
   <ng-container *ngFor="let step of progressBarData; let i = index">
      <!-- En Route -->
      <ng-container *ngIf="shouldShowEnRoute(i,step.stopNumber)">
         <div class="step">
            <div class="circle-wrapper completed">
               <div class="circle completed">
                  <img [src]="'assets/img/icons/status-bar/en-route.svg'" [alt]="step.stepName">
               </div>
            </div>
            <div class="enroute-desc">
               <div class="d-flex align-items-center gap-2 ">
                  <i class="bi bi-clock-fill enroute-icon mr-2"
                     [pTooltip]="(( latestEnrouteEvent?.timeStamp|formateDate:step.timezone)||'Pending')"
                     [escape]="false" tooltipPosition="bottom" tabindex="0" tooltipEvent="focus"></i>
                  <p class="m-0">
                     En Route to stop {{ shipmentEvents.currentStopIndex }}
                  </p>
               </div>

               <div class="subtext mt-1">Distance to Next Stop: {{ shipmentEvents.remainingMiles| number:'1.2-2' }}
                  mi</div>
            </div>
         </div>
      </ng-container>
      <!-- Steps  -->
      <div class="step">
         <!-- Step Circle  -->
         <div class="circle-wrapper"
            [ngClass]="{'completed':step.status==='arrived'||step.status==='depart'||step.status==='completed'||isShipmentCompleted()||i===0||i<shipmentEvents.currentStopIndex,'first-step': i === 0}">
            <div class="circle">
               <div>
                  <img [src]="'assets/img/icons/status-bar/'+step.icon+'.svg'" [alt]="step.stepTitle"
                     [ngClass]="{'custom-filter' : (step.status === 'pending' && i !== 0) && i >= shipmentEvents.currentStopIndex}" />
               </div>
            </div>
         </div>
         <div class="d-flex align-items-center">
            <!-- Step Info  -->
            <div class="d-flex align-items-center gap-2">
               <div class="info-icons mt-0 mr-2" *ngIf="i!==0 && i<progressBarData.length-1">
                  <span style="background-color: #333333;">
                     <i class="bi bi-calendar-fill"
                        [pTooltip]="'<span>Appointment Time</span><br>' +((step.appointmentDate|formateDate:step.appointmentTimezone )||'Pending')"
                        tooltipPosition="bottom" [escape]="false" tabindex="0" tooltipEvent="focus"></i>
                  </span>

                  <ng-container *ngIf="step.status!=='pending'">
                     <span [ngClass]="{
                      'icon-green': getTimediff(step.appointmentDate, step.timeStamp) >= -60 
                                  || getTimediff(step.appointmentDate, step.timeStamp) <= 60,
                      'icon-yellow': getTimediff(step.appointmentDate,step.timeStamp)<-60,
                      'icon-red': getTimediff(step.appointmentDate,step.timeStamp)>60}" class="enroute-icon" [pTooltip]="'<span>' +
                                        (step.status === 'arrived' ? 'Arrival Time' :'Departure Time') +
                                        '</span><br>' + ((step.timeStamp|formateDate:step.timezone )||'Pending' )"
                        tooltipPosition="bottom" [escape]="false" tabindex="0" tooltipEvent="focus">
                        <i class="bi bi-clock-fill"></i>
                     </span>
                  </ng-container>
                  <ng-container *ngIf="step.status!=='pending'">
                     <span [ngClass]="{
                      'location-icon--green': isWithinHalfMile(step),
                      'location-icon--red':   !isWithinHalfMile(step)
                    }" [pTooltip]="'<span>Location</span><br>' +(step.address || 'Pending')" tooltipPosition="bottom" [escape]="false"
                        tabindex="0" tooltipEvent="focus">
                        <i class="bi bi-geo-alt-fill"></i>
                     </span>
                  </ng-container>

               </div>
               <!--First Stop Title Section  -->
               <div>
                  <div>
                     <i class="mr-2 bi bi-clock-fill" *ngIf="i===0" [style.color]="step.appointmentDate?'#56CB4E':'#333333'"
                        [pTooltip]="'<span>Created Date</span> <br>' + (step.appointmentDate | formateDate:selectedTimeZone:step.appointmentTimezone)||'Pending'"
                        [escape]="false" tooltipPosition="bottom" tabindex="0" tooltipEvent="focus"></i>
                     <span> {{ step.stopTitle }}</span>
                  </div>
                  <div class="mt-1 d-flex gap-2" *ngIf="i===0">
                     <i class="mr-2 bi bi-clock-fill" [style.color]="step.timeStamp?'#56CB4E':'#333333'"
                        [pTooltip]="'<span>Started Date</span><br>' +((step.timeStamp|formateDate:selectedTimeZone:step.appointmentTimezone )||'Pending')"
                        tooltipPosition="bottom" [escape]="false" tabindex="0" tooltipEvent="focus"></i>
                     <span>Started</span>
                  </div>
               </div>
            </div>
         </div>
      </div>


   </ng-container>
</div>